// 1. Content Mapper for B2C T44
import { getAssetUrl } from '../../Common/Utils/assetUrl';

// Used only to pick a readable default text color when a bgColor is set via the CMS
// without a matching textColor (e.g. headerJson: { bgColor: "#000000" } and nothing else).
const isDarkColor = (hex) => {
  if (typeof hex !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(hex)) return false;
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 140;
};

export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  const brandColor1 = theme.themeColor1 || theme.themecolor1;
  const topBarBgResolved = topBar.bgColor || brandColor1 || '#0b2a1a';
  const footerBgResolved = footer.bgColor || brandColor1 || '#0b2a1a';

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
    logoUrl: getAssetUrl(tenantData?.branding?.logoUrl) || '/assets/images/logo.png',
    companyName: tenantData?.branding?.companyName || 'Travel Agency',
    brandName:   tenantData?.branding?.brandName   || 'Travel Agency',

    email:    tenantData?.branding?.email    || 'info@travelagency.com',
    phones:   tenantData?.branding?.phones   || '9000000000',
    whatsapp: tenantData?.branding?.whatsapp || '9000000000',
    socials:  tenantData?.branding?.socials  || {},

     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

     aboutUs: tenantData?.aboutUs || {},
     contactUs: tenantData?.contactUs || {},
    faq: tenantData?.faq || {},
    terms: tenantData?.terms || {},
    privacyPolicy: tenantData?.privacyPolicy || {},
      refundPolicy: tenantData?.refundPolicy || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    // topBarBg/footerBg fall back to the tenant's own primary brand color (theme1) when no
    // explicit topBar/footer override is set, rather than a template-fixed color — otherwise
    // most tenants (who never set topBarJson/footerJson.bgColor) never see their own palette.
    topBarBg:   topBarBgResolved,
    topBarText: topBar.textColor || (isDarkColor(topBarBgResolved) ? '#ffffff' : '#12261a'),
    headerBg:   header.bgColor  || '#ffffff',
    headerText: header.textColor || (isDarkColor(header.bgColor) ? '#ffffff' : '#12261a'),
    footerBg:   footerBgResolved,
    footerText: footer.textColor || (isDarkColor(footerBgResolved) ? '#ffffff' : '#12261a'),
    footerAboutText: footer.aboutText || 'We bring the world closer. Book flights, hotels, buses and holidays at the best prices.',
    footerCopyright: footer.copyright || `© ${new Date().getFullYear()} ${tenantData?.branding?.brandName || 'Travel Agency'}. All Rights Reserved.`,

    headingFont: tenantData?.branding?.headingFont || 'Sora',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',

    heroData: {
      flights: {
        title:     hero.flights?.title    || 'Search & Book Flights',
        subTitle:  hero.flights?.subTitle || 'Millions of cheap flights. One simple search.',
        textColor: hero.flights?.textColor || '#ffffff',
        bgImage:   hero.flights?.bgImage,
      },
      hotels: {
        title:     hero.hotels?.title    || 'Search & Book Hotels',
        subTitle:  hero.hotels?.subTitle || 'Best hotel deals at lowest prices.',
        textColor: hero.hotels?.textColor || '#ffffff',
        bgImage:   hero.hotels?.bgImage,
      },
      holidays: {
        title:     hero.holidays?.title    || 'Explore Holiday Packages',
        subTitle:  hero.holidays?.subTitle || 'Tailor-made holidays for every budget.',
        textColor: hero.holidays?.textColor || '#ffffff',
        bgImage:   hero.holidays?.bgImage,
      },
      sightseeing: {
        title:     hero.sightseeing?.title    || 'Discover Activities',
        subTitle:  hero.sightseeing?.subTitle || 'Experiences you will treasure forever.',
        textColor: hero.sightseeing?.textColor || '#ffffff',
        bgImage:   hero.sightseeing?.bgImage,
      },
    },
  };
};

// 2. Color Resolver for B2C T44
export const getB2CColors_T44 = (landingData) => {
  const c1 = landingData.themeColor1 || '#15803d';
  return {
    theme1:     c1,
    theme2:     landingData.footerBg   || '#0b2a1a',
    theme3:     landingData.headerBg   || '#ffffff',
    theme4:     landingData.themeColor4 || '#F1FBF3',
    theme5:     landingData.themeColor5 || '#ffffff',
    accent:     landingData.themeColor2 || '#f0a13c',
    headerText: landingData.headerText || '#12261a',
    footerText: landingData.footerText || '#ffffff',
    topBarBg:   landingData.topBarBg   || '#0b2a1a',
    topBarText: landingData.topBarText || '#ffffff',
  };
};
